module.exports = __webpack_public_path__ + "img/ezra-lee.366deadd.png";